// `DISCOVERY_SUITE` is deprecated, switch to ADDON_DISCOVERY_SUITE
export const DISCOVERY_SUITE = 'discovery_suite'
// `WATERMARKING` is deprecated, switch to ADDON_WATERMARKING
export const WATERMARKING = 'watermarking'
// `STORAGE` is deprecated, switch to ADDON_TRACKS_STORAGE
export const STORAGE = 'storage'
// `USER` is deprecated, switch to ADDON_SEATS
export const USER = 'user'

export const ADDON_DISCOVERY_SUITE = 'discovery-suite'
export const ADDON_WATERMARKING = 'watermarking'
export const ADDON_STORAGE = 'tracks-storage'
export const ADDON_SEATS = 'seats'

export type ChargebeeBillingProviderComponentsTypes =
  /*
    These are defined in the BE as ChargebeeEntitlementType, and
    are the ids in Chargebee test site too.
  */
  'seats' | 'tracks-storage' | 'watermarking' | 'discovery-suite'

export type BillingProviderComponentsTypes =
  ChargebeeBillingProviderComponentsTypes
